import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionLoadGridDataRequest,
  actionLoadGridDataSuccess,
  actionLoadGridDataFail,
} from 'react-redux-app/lib/modules/grid/actions';
import { actionAddCampaigns } from '../../campaign/actions/campaigns';
import { actionAddSites } from './index';

import { SITES_GRID_NAME } from '../constants';
import { SITES_SCHEMA } from '../schemas';

import { removeBlankFields } from 'react-redux-app/lib/modules/core/utils';
import { getGridFilter } from '../utils';


export const actionLoadSitesRequest = () => (
  (dispatch, getState, { apiClientHelper, history: { location } }) => {
    dispatch(actionLoadGridDataRequest(SITES_GRID_NAME));

    const filter = getGridFilter(location);

    return apiClientHelper.get(
      '/rest/webmaster/site',
      { params: removeBlankFields(filter) },
      SITES_SCHEMA
    ).then(
      ({ entities, result }) => {
        dispatch(actionAddCampaigns(entities.campaigns));
        dispatch(actionAddSites(entities.sites));

        dispatch(actionLoadGridDataSuccess(
          SITES_GRID_NAME, result.items, result.count, result.summary
        ));
      },
      error => {
        dispatch(actionLoadGridDataFail(SITES_GRID_NAME, error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
